var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 3.83334H3.33366C2.89163 3.83334 2.46771 4.00893 2.15515 4.32149C1.84259 4.63405 1.66699 5.05798 1.66699 5.5V17.1667C1.66699 17.6087 1.84259 18.0326 2.15515 18.3452C2.46771 18.6577 2.89163 18.8333 3.33366 18.8333H15.0003C15.4424 18.8333 15.8663 18.6577 16.1788 18.3452C16.4914 18.0326 16.667 17.6087 16.667 17.1667V11.3333",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.417 2.58333C15.7485 2.25181 16.1982 2.06557 16.667 2.06557C17.1358 2.06557 17.5855 2.25181 17.917 2.58333C18.2485 2.91485 18.4348 3.36449 18.4348 3.83333C18.4348 4.30217 18.2485 4.75181 17.917 5.08333L10.0003 13L6.66699 13.8333L7.50033 10.5L15.417 2.58333Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.85d6589ca7e513e6342b3a296103c83f.svg";
export { ForwardRef as ReactComponent };